import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

/**
 * PareText custom component
 *
 */
export default function H3Image({
  isInternalLink,
  isExternalLink,
  className,
  src,
  alt,
  internalUrl,
  externalUrl,
  onClick,
  style,
  loading='lazy',
}) {
  return (
    (isInternalLink || isExternalLink)
      ? (
        <Link to={internalUrl || externalUrl}>
          <img src={src} loading={loading} alt={alt} className={className} />
        </Link>
      )
      : <img src={src} alt={alt} className={className} onClick={() => onClick ? onClick() : {} } style={style} />
  );
}

H3Image.propTypes = {
  isInternalLink: PropTypes.bool,
  isExternalLink: PropTypes.bool,
  className: PropTypes.string,
  src: PropTypes.any,
  alt: PropTypes.any,
  internalUrl: PropTypes.string,
  externalUrl: PropTypes.string,
  onClick: PropTypes.func,
};
